import type { GetUserInfo } from "@/services/api/cronos/user/info/get"
import type { User } from "@/shared/entities/users"

export default function transformUserInfo(userInfoByToken: GetUserInfo): User {
  const { userRole: role, ...restOfUserInfo } = userInfoByToken

  const user = {
    ...restOfUserInfo,
    role,
  }

  return user
}
